module.exports = __webpack_public_path__ + "img/素菜.e2821864.png";